import { render, staticRenderFns } from "./SuperRequestsForPaymentPage.vue?vue&type=template&id=392bd95d&scoped=true"
import script from "./SuperRequestsForPaymentPage.vue?vue&type=script&lang=js"
export * from "./SuperRequestsForPaymentPage.vue?vue&type=script&lang=js"
import style0 from "./SuperRequestsForPaymentPage.vue?vue&type=style&index=0&id=392bd95d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392bd95d",
  null
  
)

export default component.exports